import gql from 'graphql-tag';

export default gql`
  fragment MinimalUserProfile on MinimalUserProfile {
    id
    full_name
    image {
      bucket
      key
      width
      height
    }
  }
`;
